var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.attribute.type
    ? _c(
        "div",
        {
          staticClass: "rb-product-tile__attribute",
          class: _vm.className,
          attrs: { "data-mnt-product-badge": _vm.label },
        },
        [
          _vm.icon
            ? _c("rb-lazy-icon", { attrs: { icon: _vm.icon } })
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "--type" }, [_vm._v(_vm._s(_vm.label))]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }